// extracted by mini-css-extract-plugin
module.exports = {"container":"Detail_container__mMVEr","cont":"Detail_cont__2K47I","title":"Detail_title__1s2fh","wei":"Detail_wei__c5BTd","btn":"Detail_btn__Bac1l"};